import { render, staticRenderFns } from "./AuthTokenize.vue?vue&type=template&id=4ffd5d1c"
import script from "./AuthTokenize.vue?vue&type=script&lang=js"
export * from "./AuthTokenize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports